import { render, staticRenderFns } from "./currentWorkPart.vue?vue&type=template&id=55736c60&scoped=true"
import script from "./currentWorkPart.vue?vue&type=script&lang=js"
export * from "./currentWorkPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55736c60",
  null
  
)

export default component.exports